import React from 'react';
import MdiIcon from '@mdi/react';
import {
  mdiChevronRight,
  mdiChevronDown,
  mdiEarth,
  mdiLan,
  mdiMapMarker,
  mdiApplicationOutline,
  mdiDragVertical,
  mdiMagnify,
  mdiInformationOutline,
  mdiAlertOutline,
  mdiCheck,
  mdiPlus,
  mdiDotsVertical,
  mdiCellphone,
  mdiSwapVertical,
  mdiClose,
  mdiUnfoldMoreHorizontal,
  mdiUnfoldLessHorizontal,
  mdiHelpCircleOutline,
  mdiSitemap,
  mdiFileDocumentOutline,
  mdiImageMultipleOutline,
  mdiTagOutline,
  mdiAccountMultipleOutline,
  mdiShieldAccountOutline,
  mdiFileImport,
  mdiProgressCheck,
  mdiAccountGroupOutline,
  mdiShieldOutline,
  mdiAccountTieOutline,
  mdiAccountSupervisorOutline,
  mdiPaletteOutline,
  mdiCogOutline,
  mdiTune,
  mdiLoginVariant,
  mdiFormatListBulleted,
  mdiPlayCircleOutline,
  mdiPuzzleOutline,
  mdiAccountPlusOutline,
  mdiLayersTriple,
  mdiCardAccountDetailsOutline,
  mdiCheckboxMultipleOutline,
  mdiSwapHorizontal,
  mdiPencilOutline,
  mdiTrashCanOutline,
} from '@mdi/js';

export { mdiDotsVertical, mdiPencilOutline, mdiTrashCanOutline, mdiSwapHorizontal, mdiHelpCircleOutline, mdiMagnify, mdiFileImport };

const I = (path: string, size = 1) => <MdiIcon path={path} size={size} />;

export const Icon = {
  chevronRight:  I(mdiChevronRight,          0.7),
  chevronDown:   I(mdiChevronDown,           0.65),
  globe:         I(mdiEarth,                 0.85),
  building:      I(mdiLan,                   0.75),
  location:      I(mdiMapMarker,             0.75),
  site:          I(mdiApplicationOutline,    0.75),
  drag:          I(mdiDragVertical,          0.75),
  search:        I(mdiMagnify,              0.75),
  info:          I(mdiInformationOutline,    0.65),
  warning:       I(mdiAlertOutline,          1),
  check:         I(mdiCheck,                0.65),
  plus:          I(mdiPlus,                 0.6),
  more:          I(mdiDotsVertical,         0.7),
  mobile:        I(mdiCellphone,            0.65),
  convert:       I(mdiSwapVertical,         0.6),
  close:         I(mdiClose,               0.7),
  expandAll:     I(mdiUnfoldMoreHorizontal, 0.7),
  collapseAll:   I(mdiUnfoldLessHorizontal, 0.7),
  help:          I(mdiHelpCircleOutline,    0.85),
  fileImport:    I(mdiFileImport,           0.75),
  nav: {
    // Content / Site section
    navigation:        I(mdiSitemap,                   0.75),
    contentTypes:      I(mdiFileDocumentOutline,        0.75),
    media:             I(mdiImageMultipleOutline,        0.75),
    metadata:          I(mdiTagOutline,                 0.75),
    roles:             I(mdiShieldOutline,              0.75),
    siteAdmins:        I(mdiAccountTieOutline,          0.75),
    siteGroups:        I(mdiAccountSupervisorOutline,   0.75),
    style:             I(mdiPaletteOutline,             0.75),
    // Mobile section
    generalSettings:   I(mdiCogOutline,                0.75),
    customization:     I(mdiTune,                      0.75),
    login:             I(mdiLoginVariant,               0.75),
    mobileNavigation:  I(mdiFormatListBulleted,           0.75),
    appConfig:         I(mdiCellphone,                  0.75),
    // Play section
    videoUsage:        I(mdiPlayCircleOutline,          0.75),
    // Platform section
    orgUnits:          I(mdiSitemap,                   0.75),
    orgAssign:         I(mdiProgressCheck,              0.75),
    platformSettings:  I(mdiCogOutline,                0.75),
    domainsManagement: I(mdiEarth,                     0.75),
    featuresManagement:I(mdiCheckboxMultipleOutline,   0.75),
    extensions:        I(mdiPuzzleOutline,              0.75),
    globalAdmins:      I(mdiAccountPlusOutline,         0.75),
    providerSettings:  I(mdiLayersTriple,              0.75),
    userManagement:    I(mdiCardAccountDetailsOutline,  0.75),
    platformGroups:    I(mdiAccountGroupOutline,        0.75),
    sites:             I(mdiEarth,                     0.75),
    // Legacy
    users:             I(mdiAccountMultipleOutline,     0.75),
    permissions:       I(mdiShieldAccountOutline,       0.75),
  },
};
